import React, { Component } from 'react';
import ScrollFadeIn from "./../../components/scrollFadeIn";
import {Helmet} from "react-helmet";

export default class BlogDetail extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>{'Kat Medina Blog | Articles | Observations'}</title>
          <meta name="description" content="Why We Need Challenges article by Kat Medina, author of the book, The Joys of Jet Lag. An article about fulfillment, overcoming challenges, and personal growth." />
        </Helmet>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Last fall I was in Austria for a 10-day solo trip full of hiking and apple strudels (it’s all about balance, right?). The second to last day I was looking forward to my final hike up the Nordkette: a tough 5-hour hike of mostly switchbacks that ends with panoramic views of Innsbruck. A definitive butt-buster.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'The problem? I had a torn labrum, partially torn hamstring and hip bursitis.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'After a week full of hikes and days that involved wandering for hours through the narrow cobblestone Austrian streets, I was definitely feeling it with every step I took.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'After weighing the options of responsibility vs. desire, I begrudgingly decided to take the cable car up instead to ensure I would still be mobile on my last day, even though I would typically scoff at the idea of taking the easy route up.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'I like the feeling that comes from pushing past my limits. It’s a love-hate relationship, but as much as I may be bitching to myself mid-hike, legs on fire, sweat in my eyes, I’m always glad I did it once I get to the top.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'The cable car took about 20 minutes and was packed full of people gasping in awe of the view. I watched the handful of hikers on the switchbacks far below, trudging forward, pausing to take a break every few steps and remove another piece of clothing deemed unnecessary as their body temp increased. Damn, it looked hard. I sipped water and pulled my jacket tighter, feeling the chill in the air as my resting heart rate stayed at a consistent 59.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'We exited at the top of Karwendel Nature Park and there was a small café where you could get a bite to eat and take in the view. Just beyond the café, there was a network of trails that ranged from beginner to advanced, the latter connecting to the hike I had longed to do. I decided after such a strenuous ride up, I deserved a strudel before exploring a bit. '}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'After my Austrian apple (strudel) a day, I wandered a little way down it and perched upon a rocky ledge that gave a 360-degree panoramic view of Innsbruck.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Hot damn, it was stunning.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'But it was missing something. One of the best parts about hiking is earning the view. Pushing yourself, making progress, cursing each step as you sweat balls up a steep incline. Then, taking it all in from the top, knowing it was worth it.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Some of the hikers I saw as I took the cable car up started to approach the top and I watched as they took in the view. Joy. Relief. Gratitude. Pride. The accomplishment of such an athletic feat gave them something more than just the feeling of achievement. It gave them fulfillment.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'As much as I try to mitigate difficulties in daily life (especially the insane obstacles involved in becoming a published author) I know deep down that I will appreciate the success more if it was difficult to achieve.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Don’t get me wrong. I love it when things come easily. It’s fucking awesome when everything just flows together and, as DJ Khaled would say, all I do is win. I’m not a sadist who enjoys punishing myself with a figurative ball gag and whip as I try to get what I want (although you may think that after my hiking anecdote).'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'The thing is, when we really have to work for something and we face challenges along the way, we not only experience happiness for having accomplished it, we experience pride.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'That genuine sense of pride only occurs when we push ourselves past the doubt, past the judgments, past the criticism. It comes from resilience, tenacity, conviction, and an unwavering commitment to getting back up again no matter how many times we fall. And that pride is the key to transforming any success into fulfillment–making the difficulty of the climb to the top totally worth it.'}
          </p>
        </ScrollFadeIn>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/blogDetail/challenges.js